module.exports = __webpack_public_path__ + "img/Hp.de2cdb97.svg";